<template>
	<div class="widget widget-kpi" :class="{ 'fullscreen-widget': isFullscreen, [params.shape]: params.shape }" ref="widgetRootRef">
		<v-card class="mx-auto" flat>
			<template v-if="!isLoading">
				<v-btn v-if="isSheetLayout" class="widget-back-fab" icon variant="flat" :aria-label="t('Back')" @click="toggleFullscreen">
					<v-icon>chevron_left</v-icon>
				</v-btn>

				<v-toolbar color="transparent" density="compact" @click="toggleFullscreen" v-if="isFullscreen">
					<div class="v-card-top-actions" v-if="!isSheetLayout">
						<span>
							<v-icon>chevron_left</v-icon>
							{{ t('Back') }}
						</span>
					</div>
					<v-toolbar-title>
						{{ title }}
					</v-toolbar-title>
					<div class="v-card-top-actions">
						<v-icon v-if="!isFullscreen">arrow_circle_right</v-icon>
					</div>
				</v-toolbar>

				<v-card-text>
					<Kpi v-show="!isFullscreen" :title="title" :color="kpi.color" :width="kpi.width" :params="params" :guid="guid" :show-difference="false" @click="toggleFullscreen" />
					<KpiBuilder v-if="isFullscreen" :title="title" :color="kpi.color" :width="kpi.width" :params="params" :guid="guid" />
				</v-card-text>
			</template>

			<template v-else>
				<v-progress-circular indeterminate :color="kpi.color" :width="kpi.width"></v-progress-circular>
			</template>
		</v-card>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch, inject, nextTick } from 'vue';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { useTranslator } from '@/composables/useTranslator';
import { eventBus } from '@/utils/core/eventBus';
import { deviceUtils } from '@/utils/core/deviceUtils';
import Kpi from '@/components/kpi/Kpi.vue';
import KpiBuilder from '@/components/kpi/KpiBuilder.vue';

// #region DATA

const t = useTranslator();
const dateHelper = iframeDataBridge.getDateHelper();
const enumAppointment = iframeDataBridge.enumAppointment;
const user = iframeDataBridge.getCurrentUser();

const isFullscreen = ref(false);
const isTouchMode = ref(deviceUtils.isTouchMode());
const isSheetLayout = computed(() => isFullscreen.value && isTouchMode.value);
const widgetRootRef = ref(null);
const kpi = ref({
	color: 'primary',
	width: 12,
});

const onResize = () => {
	isTouchMode.value = deviceUtils.isTouchMode();
};

const props = defineProps({
	title: String,
	params: Object,
	guid: String,
});

const isLoading = ref(false);

// #endregion

// #region LIFECYCLE

onMounted(() => {
	init();
	window.addEventListener('resize', onResize);
});

onBeforeUnmount(() => {
	window.removeEventListener('resize', onResize);
});

// #endregion

// #region METHODS

function init() {}

function toggleFullscreen() {
	isFullscreen.value = !isFullscreen.value;

	eventBus.emit('widget-fullscreened', {
		widget: 'widget-kpi',
		fullScreened: isFullscreen.value,
	});
}

defineExpose({
	toggleFullscreen,
	isFullscreen,
});

// #endregion
</script>
